import { httpPost } from './request/index'

// 分类管理列表
export function getList (data) {
  return httpPost('/evaluateCategory/getList', data)
}
// 添加分类
export function classifySave (data) {
  return httpPost('/evaluateCategory/save', data)
}
// 删除分类
export function del (data) {
  return httpPost('/evaluateCategory/del', data)
}

// 添加估价
export function save (data) {
  return httpPost('/evaluateSpecifications/save', data)
}

// 估价列表
export function evaluate (data) {
  return httpPost('/evaluateSpecifications/getList', data)
}

// 删除估价列表
export function evaluateDel (data) {
  return httpPost('/evaluateSpecifications/del', data)
}

// 导入估价列表
export function fications (data) {
  return httpPost('/evaluateSpecifications/importEvaluateSpecifications', data)
}

